
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"10","height":"10","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_3913_2927)","fill":"#000"}},[_c('path',{attrs:{"opacity":".3","d":"M5.05.1l2.475 2.276L9.9 4.555H.1l2.475-2.179L5.05.1z"}}),_c('path',{attrs:{"d":"M5.05 10l2.475-2.277L9.9 5.544H.1l2.475 2.179L5.05 10z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_3913_2927"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h10v10H0z"}})])])])
          )
        }
      }
    